const messages = {
  title: "Marketing Consents",
  required: "Required",
  answered: "✓ Answered",
  read: "Read",
  notRead: "Not read",
  alreadyAnswered: "Already answered",
  requiredQuestionsMustBeAccepted: "{count} required question{plural} must be accepted",
  pleaseAnswerQuestions: "Please answer the following questions:",
  iAccept: "I accept",
  scrollToUnlock: "Scroll to the bottom to unlock",
  fieldRequired: "This field is required",
  scrollToContinue: "↓ Scroll to the bottom to continue",
  saving: "Saving...",
  saveConsents: "Save Consents",
  allRequiredAccepted: "✓ All required questions accepted",
  requiredConsentsCompleted: "{completed}/{total} required consents completed",
  selectConsentToView: "Select a consent from the list to view its content",
  readAllContentFirst: "Read all content first: {names}",
  acceptAllRequiredIn: "Accept all required questions in: {names}",
  acceptAllBeforeSaving: "Please accept all required questions before saving.",
  failedToSave: "Failed to save consents. Please try again.",
  errorSaving: "An error occurred while saving consents. Please try again.",
  failedToLoad: "Failed to load consents. Please refresh the page.",
  viewPdf: "View PDF",
  requiredConsentTitle: "Required consent",
  acceptAndContinue: "Accept and continue",
};

export default {
  messages,
};
